const SSRStore = {
	countryCode: "",
	languageCode: "",
	currencyCode: "",
	platform: "",
	origin: "",
	meta: null,
	hostname: "",
	api: "",
	userAgent: "",
	href: "",
	search: "",
	isUat: false,
	id: "",
	cookies: "",
};

type SSRStoreKey = keyof typeof SSRStore;

export function getSnapshoot() {
	return SSRStore;
}

export function getSnapshootByKey(key: SSRStoreKey) {
	return SSRStore[key];
}

export function updateStore(params: { [key in SSRStoreKey]: any }) {
	for (let p in params) {
		if (params.hasOwnProperty(p)) {
			SSRStore[p] = params[p];
		}
	}
}

export function isSSR() {
	return __SERVER__;
}

export function runInServer() {
	return typeof window === "undefined";
}

export function getSearchString(): string {
	return runInServer() ? getSnapshootByKey("search") : window.location.search;
}

export function getOrigin(): string {
	return runInServer() ? getSnapshootByKey("origin") : window.location.origin;
}

export function getUserAgent(): string {
	const ua = runInServer() ? getSnapshootByKey("userAgent") : window.navigator.userAgent;
	return ua;
}
export function getCookies(): string {
	return runInServer() ? getSnapshootByKey("cookies") : "";
}
